import { render, staticRenderFns } from "./AddTaskList.vue?vue&type=template&id=039b1e56"
import script from "./AddTaskList.vue?vue&type=script&lang=js"
export * from "./AddTaskList.vue?vue&type=script&lang=js"
import style0 from "./AddTaskList.vue?vue&type=style&index=0&id=039b1e56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports